import React, { createContext, useContext, useState } from 'react';

const AIContext = createContext();

export const useAI = () => {
  const context = useContext(AIContext);
  if (!context) {
    throw new Error('useAI must be used within an AIProvider');
  }
  return context;
};

export const AIProvider = ({ children }) => {
  const [showAISuggestions, setShowAISuggestions] = useState(false);

  const toggleAISuggestions = () => {
    setShowAISuggestions(prev => !prev);
  };

  return (
    <AIContext.Provider value={{
      showAISuggestions,
      setShowAISuggestions,
      toggleAISuggestions
    }}>
      {children}
    </AIContext.Provider>
  );
};
